// Splits the agent's editTemplate actions into the ones to apply and a note for each editSection
// whose path runs past the end of a list in its section, which is refused instead. Each edit is
// checked against a copy of its section with the earlier accepted edits applied, the order the
// builder applies them in, so an append followed by an edit of the new entry passes.
export const refuseAgentEditsPastListEnd = (template, actions) => {
  const refusedEdits = [];
  const sectionDataCopies = {};
  const acceptedActions = (actions || []).filter((action) => {
    if (action.type !== 'editSection') return true;

    const section = template?.sections?.find((item) => item.id === action.sectionId);
    if (!section) return true;

    sectionDataCopies[action.sectionId] ??= _cloneDeep(section.data);
    const pastEnd = findIndexPastListEnd(sectionDataCopies[action.sectionId], action.path);
    if (pastEnd) {
      refusedEdits.push(`${action.sectionId} ${action.path}: ${pastEnd.listPath} has ${pastEnd.length} entries, so index ${pastEnd.index} is past the end and nothing was saved for this edit.`);
      return false;
    }

    _set(sectionDataCopies[action.sectionId], action.path, action.newValue);
    return true;
  });

  return { acceptedActions, refusedEdits };
};
